import { AppTrans } from '@mntn-dev/app-common'
import { linkTargetResolver } from '@mntn-dev/app-routing'
import { Feed } from '@mntn-dev/ui-components'
import { ActivityContainer } from '../activity-container.tsx'
import { Link } from '../link.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectServiceAdded = ({
  activity,
  activity: {
    activityId,
    actor,
    details: {
      activityType,
      data: { isChangeOrder = false, target },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_service_added'>) => (
  <ActivityContainer {...{ activity }}>
    <Feed.Summary>
      <AppTrans
        t={t}
        i18nKey={`${activityType}.summary`}
        values={{
          subject: actor.displayName,
          project: target.project,
          service: target.service,
        }}
      />
    </Feed.Summary>
    <Feed.Annotations>
      {isChangeOrder && (
        <Feed.Tag
          type="info"
          dataTestId={`activity-feed-item-${activityId}-change-order-tag`}
          dataTrackingId={`activity-feed-item-${activityId}-change-order-tag`}
        >
          {t(`${activityType}.change_order`)}
        </Feed.Tag>
      )}
      <Link
        {...{
          target: linkTargetResolver.project({ target }),
          t,
          onNavigate,
          currentUrl,
          dataTestId: `activity-feed-item-${activityId}-view-project-link`,
          dataTrackingId: `activity-feed-item-${activityId}-view-project-link`,
        }}
      />
    </Feed.Annotations>
  </ActivityContainer>
)
